export default "__VITE_ASSET__BTCQ8VuO__"